type FragmentStateType = {
  rootElementId: string;
  hydrated?: boolean;
  appIdentifier: string;
  fragmentType: string;
  isFragment: boolean;
};

const STATE_JSON_ELEMENT_ID = `${WEBPACK_APP_IDENTIFIER}-state`;
let fragmentState: FragmentStateType | null = null;
export function getFragmentStateValue() {
  if (!fragmentState) {
    const stateElement = document.getElementById(STATE_JSON_ELEMENT_ID);
    if (stateElement) {
      fragmentState = JSON.parse(stateElement.textContent);
    }
  }
  return fragmentState;
}
